<template>
  <div
    :class="{'ui-select': true, 'ui-select--open': open || opened }"
    tabindex="1"
    @blur="open = false"
    v-on="{
        [this.$panorama.utils.isMobile ? 'touchstart' : 'click']: toggle
      }"
  >
    <div
      v-if="!opened && items.length > 0"
      class="ui-select__tag"
    >
      <span> {{ currentItem }} </span>
      <panorama-accordion-icon :top="open" :bottom="!open"/>
    </div>
    <ul
      :class="{
        'ui-select__tags': true,
        'ui-select__tags--open': open || opened,
        'ui-select__tags--reverse': reverse
      }"
    >
      <li
        v-for="(item, index) in items"
        :key="index"
        @click="select(+index)"
        :class="{
          'ui-select__item': true,
          'ui-select__item--opened': opened,
          'ui-select__item--active': +index === activeIndex
        }"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
import PanoramaAccordionIcon from '@/components/icons/PanoramaAccordionIcon'
export default {
  name: 'PanoramaUiSelect',
  components: {
    PanoramaAccordionIcon
  },
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    reverse: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => ([])
    },
    value: {
      type: Number,
      default: 0
    }
  },
  watch: {
    value () {
      this.activeIndex = this.value
    }
  },
  computed: {
    currentItem () {
      if (this.activeIndex < 0 || this.activeIndex > this.items.length) return null
      return this.items[this.activeIndex]
    }
  },
  created () {
    this.activeIndex = this.value
  },
  data: () => ({
    activeIndex: -1,
    open: false
  }),
  methods: {
    toggle () {
      this.open = !this.open
    },
    select (index) {
      this.activeIndex = index
      this.$emit('input', index)
    }
  }
}
</script>

<style scoped lang="scss">
.ui-select {
  position: relative;
  color: var(--panorama-text-color);
  font-family: var(--panorama-first-font);
  font-weight: bold;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0.04em;
  border-radius: 3px;
  outline: none;

  @media screen and (min-width: 1920px) {
    font-size: 0.6vw;
  }

  &__item, &__tag {
    width: 120px;
    height: 32px;
    box-sizing: border-box;
    text-transform: uppercase;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 10px 8px;
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    background: var(--panorama-background-color);

    &--active, &:hover {
      background: var(--panorama-text-color);
      color: #FFF;
      & svg {
        filter: invert(1)
      }
    }

    @media screen and (min-width: 768px) {
      width: 101px;
      height: 20px;
      padding: 4px 6px 4px 8px;
    }

    @media screen and (min-width: 1920px) {
      width: 5.7vw;
      height: auto;
      padding: 6% 6% 6% 8%;
    }
  }

  &--open &__tag {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  &__item {
    border-radius: 0;
    &:last-child {
      border-bottom-right-radius: 3px;
      border-bottom-left-radius: 3px;
    }
    &--opened {
      border-radius: 3px;
      margin-bottom: 6px;
      @media screen and (min-width: 1920px) {
        margin-bottom: 0.42vw;
      }
    }
  }

  &__tags {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    text-transform: uppercase;
    max-height: 0;
    transition: all 300ms ease-in-out;
    position: absolute;
    left: 0;
    right: 0;
    opacity: 0;
    z-index: 1;

    &--reverse {
      flex-direction: column-reverse;
    }

    &--open {
      opacity: 1;
      max-height: 600px;
      overflow-x: auto;
    }
  }
}

</style>
